import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const NotesFileUploader = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [selectedFile, setSelectedFile] = useState(null);
  const [notesFile, setNotesFile] = useState(''); 
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validFileTypes = [
        "text/plain",
        "image/png", 
        "image/jpeg", 
        "image/jpg",
        "application/pdf", 
        "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
        "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
        "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "video/mp4"
      ];
      
      if (!validFileTypes.includes(file.type)) {
        setErrorMessage("Invalid file format. Allowed formats: TXT, PNG, JPEG, JPG, PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, MP4.");
        setSelectedFile(null);
        return;
      }

      if (file.size > 1024000) { 
        setErrorMessage('File size must not exceed 1 MB.');
        setSelectedFile(null);
        return;
      }
      setErrorMessage('');
      setSelectedFile(file);
    }
  };


  const onFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a valid file first.');
      return;
    }

    const ext = selectedFile.name.split('.').pop();
    const renamedFile = new File(
      [selectedFile], 
      `usernotes_${userCode}_${selectedFile.name}`, 
      { type: selectedFile.type }
    );    
    // console.log("selected file name /  renamedfilename: ",selectedFile," / ",renamedFile);


    const formData = new FormData();
    formData.append('file', renamedFile);
    formData.append('userCode', userCode);
  
    try {
      // Upload to backend
      const response = await axios.post("/api/uploads/upload-openbook-usernotes", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        alert("Image uploaded successfully!");
      } else {
        throw new Error("Failed to upload image. Server responded with status: " + response.status);
      }
    } catch (error) {
      console.error("Upload error:", error);
      setError(error.message || "An error occurred during upload.");
    } finally {
      setLoading(false);
    }
  };

  
  const navigateBack = () => {
  navigate(-1)
 }

  return (
    // <div className="flex justify-center items-center min-h-screen bg-gray-800">
      <div className="border-2 flex flex-col items-center p-6 bg-gray-700 rounded-lg w-full max-w-sm">
        <h2 className="text-lg font-bold text-white mt-4">Upload a Document, Image, Audio, Video File</h2>
        <input 
            type="file" 
            accept=".txt, .png, .jpeg, .jpg, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp4" 
            onChange={onFileChange} 
            className="mt-2 text-white"
        />
        {errorMessage && <p className="text-red-500 text-sm mt-2">{errorMessage}</p>}
        <button 
          onClick={onFileUpload} 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Upload
        </button>
        <button 
          onClick={navigateBack} 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Back
        </button>
      </div>
    // </div>

  );
};

export default NotesFileUploader;
